import { render, staticRenderFns } from "./SopCxc.vue?vue&type=template&id=4237706b"
import script from "./SopCxc.vue?vue&type=script&lang=js"
export * from "./SopCxc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports